import { UserMetadata } from '@/types/auth';

export const retrieveFromUserMetadata = (userMetadata: UserMetadata[] | null, key: string) => {
  if (!userMetadata) return null;
  const optionalValue = userMetadata.find(
    metdata => metdata.metadataKey.toLowerCase() === key.toLowerCase()
  );
  return optionalValue ? optionalValue.metadataValue : null;
};
